import { Link } from 'react-router';
import { Container } from '@/components/ui/container';

export function NotFound() {
  return (
    <Container className="py-40">
      <h1 className="text-4xl font-medium text-ink-900">Page not found</h1>
      <p className="mt-5 text-ink-500">
        The page you requested could not be found.
      </p>
      <Link className="mt-8 inline-block underline" to="/">
        Return home
      </Link>
    </Container>
  );
}
